import {Component, inject, model, OnInit, output, viewChild} from '@angular/core'
import {NgModel} from '@angular/forms'
import {KycService} from '../../services/kyc.service'

@Component({
  template: ``
})
export class InputBaseComponent<T> implements OnInit {

  /**
   * Exactly one control in this template. The subclass
   * must implement exactly one (1) item with id=input.
   * The input should be assigned the form control
   */
  public control = viewChild<NgModel>('input')

  /**
   * External view of this component's validity.
   * It is based on the control that we dig out of
   * the template.
   */
  public valid = output<boolean>()

  /**
   * The value modified by the control
   */
  public model = model<T>()

  /**
   * This should be overridden by the subclass to
   * directly set the value in "Kyc".
   * If it is a discrete value that is just fine
   * @protected
   */
  protected prop = 'value'

  protected service = inject(KycService)

  public ngOnInit() {
    /**
     * Update the model when the service value changes.
     * That is set our values from the kyc. That happens once
     * on init.
     */
    this.model.set(this.service.kycModel[this.prop] as T)


    this.control()?.valueChanges?.pipe()
      .subscribe(v => {
        this.service.kycModel[this.prop] = v
        this.valid.emit(!this.control()?.control.errors)
      })
  }
}